/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const RATING_LIMITS_SET_OPTION_LIMIT_LIST = 'RATING_LIMITS_SET_OPTION_LIMIT_LIST';
export const RATING_LIMITS_SET_SELECTED_OPTION_LIST = 'RATING_LIMITS_SET_SELECTED_OPTION_LIST';
export const RATING_LIMITS_SET_VERTICAL_LIMIT = 'RATING_LIMITS_SET_VERTICAL_LIMIT';
export const RATING_LIMITS_SET_VERTICAL_POSITION = 'RATING_LIMITS_SET_VERTICAL_POSITION';
export const RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED = 'RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED';
export const RATING_LIMITS_SET_HIGHLIGHT_POSITION = 'RATING_LIMITS_SET_HIGHLIGHT_POSITION';
